var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('el-container',[_c('transition',{attrs:{"name":"fade-transform"}},[_c('router-view',{style:({
            zIndex: 0,
            width: _vm.viewWidth + 'px',
            height: _vm.viewHeight + 'px',
            backgroundColor: 'rgba(255, 255, 255, 1)',
          })})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32d49246","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/framework/layout/layout.vue
// module id = mhFz
// module chunks = 21